import { render, staticRenderFns } from "./PopupRiskInfo_3x3_1.vue?vue&type=template&id=67b188ae&scoped=true"
import script from "./PopupRiskInfo_3x3_1.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfo_3x3_1.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfo_3x3_1.vue?vue&type=style&index=0&id=67b188ae&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfo_3x3_1.vue?vue&type=style&index=1&id=67b188ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b188ae",
  null
  
)

export default component.exports